import Grid from '../../../../../../components/Table/Grid';
import { SourceNotInTabView } from '../../SourceNotInTabView';
import { GridContainerProps } from '../types';

export function GridContainer({
  columns,
  columnVisibilityModel,
  columnOrder,
  setColumnOrder,
  columnPinning,
  setColumnPinning,
  view,
  source,
  tab,
  panelTab,
  searchItems,
  isEvidence,
  isMapping,
  mappingContent,
  setTotalResults,
  onData,
  getFilterValueRef,
  defaultFilterValue,
  sourceWeights,
  isInvalidSource,
  rowDetailColumnCatalog,
  enableEnrichmentSelection,
  getRowId,
  getRowIdForEnrichment,
  enrichmentGetSelectionRef,
  onFiltersChange,
  showSummaryMatchBar = false,
  onOpenSummaryMatch,
  isSummaryMatchLoading = false,
  summaryMatchApiParams = null,
  summaryMatchActive = false,
  summaryMatchStats = null,
  onClearSummaryMatch,
}: GridContainerProps) {
  if (isInvalidSource && columns) {
    return <SourceNotInTabView source={source} tab={tab} view={view} />;
  }

  return (
    <Grid
      columns={columns}
      columnVisibilityModel={columnVisibilityModel}
      columnOrder={columnOrder}
      setColumnOrder={setColumnOrder}
      columnPinning={columnPinning}
      setColumnPinning={setColumnPinning}
      view={view}
      source={source}
      tab={tab}
      panelTab={panelTab}
      searchItems={searchItems}
      isEvidence={isEvidence}
      isMapping={isMapping}
      mappingContent={mappingContent}
      setTotalResults={setTotalResults}
      onData={onData}
      getFilterValueRef={getFilterValueRef}
      defaultFilterValue={defaultFilterValue}
      sourceWeights={sourceWeights}
      rowDetailColumnCatalog={rowDetailColumnCatalog}
      enableEnrichmentSelection={enableEnrichmentSelection}
      getRowId={getRowId}
      getRowIdForEnrichment={getRowIdForEnrichment}
      enrichmentGetSelectionRef={enrichmentGetSelectionRef}
      onFiltersChange={onFiltersChange}
      showSummaryMatchBar={showSummaryMatchBar}
      onOpenSummaryMatch={onOpenSummaryMatch}
      isSummaryMatchLoading={isSummaryMatchLoading}
      summaryMatchApiParams={summaryMatchApiParams}
      summaryMatchActive={summaryMatchActive}
      summaryMatchStats={summaryMatchStats}
      onClearSummaryMatch={onClearSummaryMatch}
    />
  );
}